import { render, staticRenderFns } from "./DetailMetodePencairan.vue?vue&type=template&id=1566e8bd&"
import script from "./DetailMetodePencairan.vue?vue&type=script&lang=js&"
export * from "./DetailMetodePencairan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports